import { render, staticRenderFns } from "./BuildingSocietyActivity.vue?vue&type=template&id=913818a6&scoped=true&"
import script from "./BuildingSocietyActivity.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913818a6",
  null
  
)

export default component.exports